
import React from 'react';
import '../MainPage/MainPage.less'
import './faq.less'
import { withTranslation } from 'react-i18next';
import FAQCheck from '../../images/faq_check.png'
import FAQWarning from '../../images/faq_warning.png'
import FAQX from '../../images/faq_X.png'
import BackButton from '../../images/back_icon.png'

class FAQ extends React.Component {
    static defaultProps = {
        goToMain: function(){},
    }
    
    constructor(props) {
        super(props);

        this.state = {
            checks: [true,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false],
            goToMain: this.props.goToMain
        };

        if (props.register) {
            props.register(this);
        }
    }

    componentDidMount()
    {

    }

    changeCheck(idx)
    {
        var newchecks = Array(22).fill(false);;
        if (!this.state.checks[idx])
        {            
            newchecks[idx] = true;
        }                
        this.setState({checks: newchecks});
    }

    render() {
        const { t, i18n } = this.props;
        const markerDownloadUrl = i18n.language === "en"
            ? "https://www.vithrough.com/en/marker-download"
            : "https://www.vithrough.com/marker-download";
        return (
            <div className='main_page faq'>
                <div className='user_files_container'>
                    <div className='user_files_list_header' id='faq_header'>
                        <div className='user_files_list_header_left'>
                            <label id='Models'>{t('FAQ_Headline')}</label>
                        </div>
                        <div className='user_files_list_header_right'>
                            <button onClick={() => this.state.goToMain()} className='back_button'>
                                <img alt="" src={BackButton}></img>
                                <label>{t('Back_Button')}</label>
                            </button>
                        </div>
                    </div>

                    <div className='faq_container'>
                        <div className="tab">
                            <input checked={this.state.checks[0]} onChange={() => this.changeCheck(0)} type="checkbox" id="rd1" name="rd"/>

                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd1">{t('FAQ_Q1')}</label>

                            <div className="tab-content">
                            <label>{t('FAQ_A1')}</label>
                        <table className='faq_table'>
                            <tbody>
                            <tr className='table_header'>
                                <th>{t('Table_File')}</th>
                                <th>{t('Table_Model')}</th>
                                <th>{t('Table_Material')}</th>
                                <th>{t('Table_Animation')}</th>
                                <th>{t('Table_Bone')}</th>
                                <th>{t('Table_LightType')}</th>
                                <th>{t('Table_LightSource')}</th>
                            </tr>
                            <tr>
                                <td className='td_data' >FBX</td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                            </tr>
                            <tr>
                                <td className='td_data'>OBJ</td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                            </tr>
                            <tr>
                                <td className='td_data'>GLB/GLTF</td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                            </tr>
                            <tr>
                                <td className='td_data'>VRML/WRL</td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                            </tr>
                            <tr>
                                <td className='td_data'>DAE</td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_warning'><img alt="" src={FAQWarning}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                            </tr>
                            <tr>
                                <td className='td_data'>STL</td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                            </tr>
                            <tr>
                                <td className='td_data'>DXF</td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                            </tr>
                            <tr>
                                <td className='td_data'>STEP</td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_check'><img alt="" src={FAQCheck}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                                <td className='td_x'><img alt="" src={FAQX}></img></td>
                            </tr>                            
                            </tbody>
                        </table>  
                        <label>{t('FAQ_A1a')}</label>
                        <label>{t('FAQ_A1b')}</label>
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[1]} onChange={() => this.changeCheck(1)} type="checkbox" id="rd2" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd2">{t('FAQ_Q2')}</label>
                            <div className="tab-content">
                                {t('FAQ_A2')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[2]} onChange={() => this.changeCheck(2)} type="checkbox" id="rd3" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd3">{t('FAQ_Q3')}</label>
                            <div className="tab-content">
                                {t('FAQ_A3')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[3]} onChange={() => this.changeCheck(3)} type="checkbox" id="rd4" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd4">{t('FAQ_Q4')}</label>
                            <div className="tab-content">
                                {t('FAQ_A4')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[4]} onChange={() => this.changeCheck(4)} type="checkbox" id="rd5" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd5">{t('FAQ_Q5')}</label>
                            <div className="tab-content" dangerouslySetInnerHTML={{ __html: t('FAQ_A5')}}>
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[5]} onChange={() => this.changeCheck(5)} type="checkbox" id="rd6" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd6">{t('FAQ_Q6')}</label>
                            <div className="tab-content">
                                {t('FAQ_A6')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[6]} onChange={() => this.changeCheck(6)} type="checkbox" id="rd7" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd7">{t('FAQ_Q7')}</label>
                            <div className="tab-content" dangerouslySetInnerHTML={{ __html: t('FAQ_A7')}}>
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[7]} onChange={() => this.changeCheck(7)} type="checkbox" id="rd8" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd8">{t('FAQ_Q8')}</label>
                            <div className="tab-content">
                                {t('FAQ_A8')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[8]} onChange={() => this.changeCheck(8)} type="checkbox" id="rd9" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd9">{t('FAQ_Q9')}</label>
                            <div className="tab-content">
                                {t('FAQ_A9')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[9]} onChange={() => this.changeCheck(9)} type="checkbox" id="rd10" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd10">{t('FAQ_Q10')}</label>
                            <div className="tab-content">
                                {t('FAQ_A10')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[10]} onChange={() => this.changeCheck(10)} type="checkbox" id="rd11" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd11">{t('FAQ_Q11')}</label>
                            <div className="tab-content">
                                {t('FAQ_A11')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[11]} onChange={() => this.changeCheck(11)} type="checkbox" id="rd12" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd12">{t('FAQ_Q12')}</label>
                            <div className="tab-content">
                                {t('FAQ_A12')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[12]} onChange={() => this.changeCheck(12)} type="checkbox" id="rd13" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd13">{t('FAQ_Q13')}</label>
                            <div className="tab-content">
                                {t('FAQ_A13')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[13]} onChange={() => this.changeCheck(13)} type="checkbox" id="rd14" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd14">{t('FAQ_Q14')}</label>
                            <div className="tab-content">
                                {t('FAQ_A14')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[14]} onChange={() => this.changeCheck(14)} type="checkbox" id="rd15" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd15">{t('FAQ_Q15')}</label>
                            <div className="tab-content">
                                {t('FAQ_A15')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[15]} onChange={() => this.changeCheck(15)} type="checkbox" id="rd16" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd16">{t('FAQ_Q16')}</label>
                            <div className="tab-content">
                                {t('FAQ_A16')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[16]} onChange={() => this.changeCheck(16)} type="checkbox" id="rd17" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd17">{t('FAQ_Q17')}</label>
                            <div className="tab-content">
                                {t('FAQ_A17')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[17]} onChange={() => this.changeCheck(17)} type="checkbox" id="rd18" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd18">{t('FAQ_Q18')}</label>
                            <div className="tab-content">
                                {t('FAQ_A18')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[18]} onChange={() => this.changeCheck(18)} type="checkbox" id="rd19" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd19">{t('FAQ_Q19')}</label>
                            <div className="tab-content">
                                {t('FAQ_A19')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[19]} onChange={() => this.changeCheck(19)} type="checkbox" id="rd20" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd20">{t('FAQ_Q20')}</label>
                            <div className="tab-content">
                                {t('FAQ_A20')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[20]} onChange={() => this.changeCheck(20)} type="checkbox" id="rd21" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd21">{t('FAQ_Q21')}</label>
                            <div className="tab-content">
                                {t('FAQ_A21')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[21]} onChange={() => this.changeCheck(21)} type="checkbox" id="rd22" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd22">{t('FAQ_Q22')}</label>
                            <div className="tab-content">
                                {t('FAQ_A22')}
                            </div>
                        </div>
                        <div className="tab">
                            <input checked={this.state.checks[22]} onChange={() => this.changeCheck(22)} type="checkbox" id="rd23" name="rd"/>
                            <label title={t('FAQ_Button')} className="tab-label" htmlFor="rd23">{t('FAQ_Q23')}</label>
                            <div className="tab-content">
                                {t('FAQ_A23')}
                                <br/>
                                <a className="faq_link" href={markerDownloadUrl} target="_blank" rel="noopener noreferrer">{t('FAQ_A23_link')}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}
export default withTranslation()(FAQ);
